"use client";

import React from "react";
import { ModalContainer, ResponsiveModal, MODAL_IDS } from "@wtc/ui";
import { CreateTaskNoteForm } from "@/features/tasks/components/components/CreateTaskNoteForm";
import type { TaskAddNoteModalData } from "@/lib/modals/data/modal-data-types";

/**
 * Global modal: add note to a task. Open via action "Add note" or openModal(MODAL_IDS.tasks.taskAddNote, { taskId }).
 */
export function TaskAddNoteModalContainer() {
  return (
    <ModalContainer<TaskAddNoteModalData> modalId={MODAL_IDS.tasks.taskAddNote}>
      {({ isOpen, data, onClose }) => {
        const taskId = data?.taskId ?? (data?.item as { id?: string } | undefined)?.id;
        if (!isOpen || !taskId) {
          return null;
        }
        return (
          <ResponsiveModal
            open={isOpen}
            onOpenChange={(open) => !open && onClose()}
            title="Add note"
            maxWidth="md"
            side="bottom"
          >
            <CreateTaskNoteForm taskId={taskId} onSuccess={onClose} onCancel={onClose} />
          </ResponsiveModal>
        );
      }}
    </ModalContainer>
  );
}
